/**
 * InsightBanner — Renders contextual motivational insights.
 *
 * Accepts an array of insights (from motivationEngine) and
 * renders them in a compact, premium banner style.
 *
 * Usage in any page:
 *   <InsightBanner insights={overviewInsights(s, proj, pF, ...)} />
 *
 * Reusable across all pages — the engine decides what to say,
 * this component decides how to say it.
 */
import { useApp } from '../../hooks/useApp';

export default function InsightBanner({ insights }) {
  const { s, c } = useApp();

  if (!insights || insights.length === 0) return null;

  return (
    <div style={{
      display: "flex", flexDirection: "column", gap: 8,
    }}>
      {insights.map((insight, i) => (
        <div
          key={i}
          style={{
            display: "flex", alignItems: "flex-start", gap: 12,
            padding: "14px 18px", borderRadius: 14,
            background: s.dark
              ? "rgba(255,255,255,0.03)"
              : "rgba(0,0,0,0.02)",
            border: `1px solid ${s.dark
              ? "rgba(255,255,255,0.05)"
              : "rgba(0,0,0,0.04)"
            }`,
            animation: `fadeSlideUp 0.4s cubic-bezier(0.25,0.1,0.25,1) ${i * 0.08}s both`,
          }}
        >
          {/* Icon */}
          <span style={{
            fontSize: 16, lineHeight: 1.4, flexShrink: 0,
            marginTop: 1,
          }}>
            {insight.icon}
          </span>

          {/* Message */}
          <p style={{
            fontSize: 13, lineHeight: 1.55, color: c.muted,
            margin: 0, fontWeight: 450,
            letterSpacing: "-0.005em",
          }}>
            {insight.text}
          </p>
        </div>
      ))}
    </div>
  );
}
